import { UserEntitlement } from '../models/UserEntitlement'
/**
 * Parse Nagra user entitlements
 * @return {Object} data raw data from the backend
 * @param {UserEntitlement} UserEntitlement Nagra Entitlement
 */
export const UserEntitlementFactory = (data = {}) => {
    return new UserEntitlement({
        ...data,
    })
}
